import asArray from 'utils/arrays/asArray.util';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';

const filterActiveStylistsAll = (stylists) =>
  asArray(stylists)
    .filter(alwaysSame)
    .filter((s) => s.status !== 'deleted' && !s.serves_as_waitlist);

export default filterActiveStylistsAll;
